export default "__VITE_ASSET__BIkn_To3__"